export const translations = {
  fr: {
    nav: {
      home: 'Synthèse Globale',
      investorSummary: 'Synthèse Investisseur',
      resume: 'Résumé Exécutif',
      vision: 'Vision & Objectifs',
      market: 'Marché & Opportunité',
      product: 'Produit & Expérience',
      payments: 'Paiements & Sécurité',
      gtm: 'Go-to-Market',
      model: 'Modèle d\'Affaires',
      org: 'Organisation & Coûts',
      roadmap: 'Roadmap & Jalons',
      valuation: 'Valorisation',
      forecast: 'Prévisions Financières',
      pi: 'Propriété Intellectuelle',
      execution: 'Plan d\'Exécution Opérationnel'
    },
    home: {
      title: 'Plan d\'Affaires',
      subtitle: 'Transformer durablement l\'alimentation scolaire dans 10 provinces canadiennes',
      visionCard: 'Vision',
      visionDesc: '7 206 écoles ciblées (6 631 public + 575 privé) sur 12 705 TAM (10 provinces)',
      revenueCard: 'Revenus 5 ans',
      revenueDesc: 'Revenus cumulés 2026-2031',
      baiaCard: 'BAIIA 5 ans',
      baiaDesc: 'BAIIA cumulé 2026-2031',
      valueProposition: 'Proposition de Valeur',
      valuePropDesc: 'EcoLunch est une plateforme unifiée SaaS + FinTech qui standardise la gestion des repas scolaires pour parents, écoles, traiteurs et CSS.',
      saasModel: 'Modèle SaaS',
      saasDesc: 'Formules Essentiel, Plus et Signature avec revenus récurrents',
      fintech: 'FinTech',
      fintechDesc: '2,5% + 0,15$ par transaction + BNPL Sezzle',
      quebec: '100% Québec',
      quebecDesc: 'Hébergement, paiements (SonaPay) et données au QC',
      profitable: 'BAIIA Positif',
      profitableDesc: 'Rentable dès le mois 1 avec croissance durable',
      resumeTitle: 'Résumé Exécutif',
      resumeDesc: 'Vue d\'ensemble de la stratégie et du modèle d\'affaires',
      forecastTitle: 'Prévisions Financières',
      forecastDesc: 'Projections détaillées sur 60 mois avec graphiques interactifs',
      roadmapTitle: 'Roadmap & Jalons',
      roadmapDesc: 'Étapes clés du déploiement et de la croissance'
    },
    forecast: {
      title: 'Prévisions Financières',
      subtitle: 'Projections détaillées sur 60 mois (2026-2031)',
      totalRevenue: 'Revenus Totaux 5 ans',
      totalBaiia: 'BAIIA Total 5 ans',
      avgMargin: 'Marge BAIIA Moyenne',
      totalGmv: 'GMV Total 5 ans',
      calculator: 'Calculatrice Interactive',
      calculatorDesc: 'Calculez vos projections personnalisées',
      mealsPerDay: 'Repas par jour',
      pricePerMeal: 'Prix par repas ($)',
      regularParents: 'Parents réguliers',
      monthlyRevenue: 'Revenus mensuels',
      monthlyBaiia: 'BAIIA mensuel',
      yearlyTotals: 'Totaux Annuels',
      year: 'Année',
      regularGmv: 'GMV Régulier',
      sezzleGmv: 'GMV Sezzle',
      revenue: 'Revenus',
      opex: 'OPEX',
      baiia: 'BAIIA',
      margin: 'Marge %',
      monthlyDetail: 'Détail Mensuel par Année',
      month: 'Mois',
      caterers: 'Traiteurs',
      mealsDay: 'Repas/jour',
      schools: 'Écoles',
      copyLink: 'Copier lien',
      copied: 'Copié !',
      videoTitle: "EcoLunch - Transformons l'alimentation scolaire"
    },
    footer: {
      copyright: 'EcoLunch © 2026',
      businessPlan: 'Plan d\'Affaires'
    }
  },
  en: {
    nav: {
      home: 'Global Overview',
      investorSummary: 'Investor Summary',
      resume: 'Executive Summary',
      vision: 'Vision & Objectives',
      market: 'Market & Opportunity',
      product: 'Product & Experience',
      payments: 'Payments & Security',
      gtm: 'Go-to-Market',
      model: 'Business Model',
      org: 'Organization & Costs',
      roadmap: 'Roadmap & Milestones',
      valuation: 'Valuation',
      forecast: 'Financial Forecast',
      pi: 'Intellectual Property',
      execution: 'Operational Execution Plan'
    },
    home: {
      title: 'Business Plan',
      subtitle: 'Sustainably transforming school meals across 10 Canadian provinces',
      visionCard: 'Vision',
      visionDesc: '7,206 target schools (6,631 public + 575 private) out of 12,705 TAM (10 provinces)',
      revenueCard: '5-year Revenue',
      revenueDesc: 'Cumulative revenue 2026-2031',
      baiaCard: '5-year EBITDA',
      baiaDesc: 'Cumulative EBITDA 2026-2031',
      valueProposition: 'Value Proposition',
      valuePropDesc: 'EcoLunch is a unified SaaS + FinTech platform that standardizes school meal management for parents, schools, caterers, and school boards.',
      saasModel: 'SaaS Model',
      saasDesc: 'Essential, Plus and Signature packages with recurring revenue',
      fintech: 'FinTech',
      fintechDesc: '2.5% + $0.15 per transaction + BNPL Sezzle',
      quebec: '100% Quebec',
      quebecDesc: 'Hosting, payments (SonaPay) and data in QC',
      profitable: 'Positive EBITDA',
      profitableDesc: 'Profitable from month 1 with sustainable growth',
      resumeTitle: 'Executive Summary',
      resumeDesc: 'Overview of strategy and business model',
      forecastTitle: 'Financial Forecast',
      forecastDesc: 'Detailed 60-month projections with interactive charts',
      roadmapTitle: 'Roadmap & Milestones',
      roadmapDesc: 'Key deployment and growth stages'
    },
    forecast: {
      title: 'Financial Forecast',
      subtitle: 'Detailed 60-month projections (2026-2031)',
      totalRevenue: 'Total 5-year Revenue',
      totalBaiia: 'Total 5-year EBITDA',
      avgMargin: 'Average EBITDA Margin',
      totalGmv: 'Total 5-year GMV',
      calculator: 'Interactive Calculator',
      calculatorDesc: 'Calculate your custom projections',
      mealsPerDay: 'Meals per day',
      pricePerMeal: 'Price per meal ($)',
      regularParents: 'Regular parents',
      monthlyRevenue: 'Monthly revenue',
      monthlyBaiia: 'Monthly EBITDA',
      yearlyTotals: 'Annual Totals',
      year: 'Year',
      regularGmv: 'Regular GMV',
      sezzleGmv: 'Sezzle GMV',
      revenue: 'Revenue',
      opex: 'OPEX',
      baiia: 'EBITDA',
      margin: 'Margin %',
      monthlyDetail: 'Monthly Detail by Year',
      month: 'Month',
      caterers: 'Caterers',
      mealsDay: 'Meals/day',
      schools: 'Schools',
      copyLink: 'Copy link',
      copied: 'Copied!',
      videoTitle: 'EcoLunch - Transforming school meals'
    },
    footer: {
      copyright: 'EcoLunch © 2026',
      businessPlan: 'Business Plan'
    }
  }
};

export const contentTranslations = {
  fr: {
    resumeExecutif: {
      titre: 'Résumé Exécutif',
      contenu: `EcoLunch est une plateforme unifiée SaaS + FinTech qui standardise la gestion des repas scolaires (parents, écoles, traiteurs, CSS) : commande, paiement, production, rapports, gouvernance, satisfaction et sécurité des données.

**Modèle de revenus :**
• SaaS (Essentiel/Plus/Signature)
• FinTech : 2,5 % + 0,15 $ par transaction régulière
• Sezzle : 1,5 % sur 15 % volume incrémental
• Abonnements parents : 1,99 $/mois (50 % aux écoles)
• Implantation : 500 $ dès M4
• EcoLunch Connect (jumelage école↔traiteur)

**Avantage compétitif :**
Marque provinciale, hébergement & paiements 100 % Québec (SonaPay, serveurs QC), RBAC, conformité, audit.

**Levées :** 100 k$ (launch) → 500 k$ (post-launch) → 2 M$ (A2) pour scaler Québec puis Canada.

**Valorisation :** Hybride (multiples RAR + multiples GMV FinTech).`
    },
    vision: {
      titre: 'Vision & Objectifs',
      contenu: `Transformer durablement l'alimentation scolaire et faire d'EcoLunch la norme numérique officielle dans les 10 provinces canadiennes.

**Objectif 5 ans :**
• 7 206 écoles ciblées sur 12 705 TAM (~57%)
• Public : QC 1 400 (63%) | ON 2 400 (50%) | AB 1 080 (50%) | BC 925 (50%) | MB 270 (50%) | SK 200 (49%) | NB 110 (50%) | NE 138 (50%) | TNL 88 (50%) | IPE 20 (50%)
• Privé : 575 écoles (~40% TAM privé)
• Devenir la référence en gestion de repas scolaires dans 10 provinces

**Mission :**
Simplifier la vie des parents, optimiser les opérations des traiteurs, et assurer la qualité et la sécurité alimentaire pour tous les enfants.`
    },
    proprieteIntellectuelle: {
      titre: 'Propriété Intellectuelle Intégrée',
      intro: `EcoLunch repose sur une propriété intellectuelle intégrée, systémique et transversale, développée entièrement à l'interne et détenue à 100% par la société.`,
      sectionTitle: 'Composantes de la Propriété Intellectuelle – EcoTechSystème™',
      donneesTitle: 'Données Propriétaires Cumulatives',
      donnees: `L'utilisation quotidienne de l'EcoTechSystème™ génère un actif de données unique (préférences alimentaires, patterns de commande, engagement utilisateur, performance opérationnelle et benchmarks sectoriels), créant un avantage concurrentiel cumulatif et des barrières à l'entrée significatives.`,
      cloture: `ÉcoLuncH™ constitue une propriété intellectuelle intégrée, systémique et indissociable, entièrement développée à l'interne et détenue à 100 % par EcoTechSystème inc.`
    },
    planExecution: {
      titre: 'Plan d\'Exécution Opérationnel',
      intro: `Ce plan d'exécution détaille la mise en œuvre opérationnelle permettant d'atteindre les prévisions financières établies. Il structure le déploiement en 4 phases alignées avec la roadmap et les jalons institutionnels.`,
      noteAlignement: `Ce plan d'exécution est strictement aligné avec les prévisions financières, la roadmap et les jalons institutionnels présentés dans les sections suivantes.`
    }
  },
  en: {
    resumeExecutif: {
      titre: 'Executive Summary',
      contenu: `EcoLunch is a unified SaaS + FinTech platform that standardizes school meal management (parents, schools, caterers, school boards): ordering, payment, production, reporting, governance, satisfaction, and data security.

**Revenue Model:**
• SaaS (Essential/Plus/Signature)
• FinTech: 2.5% + $0.15 per regular transaction
• Sezzle: 2% on 18-25% incremental volume
• Parent subscriptions: $1.99/month (50% to schools)
• Implementation: $500 from M4
• EcoLunch Connect (school↔caterer matching)

**Competitive Advantage:**
Provincial brand, 100% Quebec hosting & payments (SonaPay, QC servers), RBAC, compliance, audit.

**Funding Rounds:** $250k (launch) → $500k (post-launch) → $2M (A2) to scale Quebec then Canada.

**Valuation:** Hybrid (ARR multiples + FinTech GMV multiples).`
    },
    vision: {
      titre: 'Vision & Objectives',
      contenu: `Sustainably transform school meals and make EcoLunch the official digital standard across 10 Canadian provinces.

**5-year Objective:**
• 7,206 target schools out of 12,705 TAM (~57%)
• QC: 1,400 (63%) | ON: 2,400 (50%) | AB: 1,080 (50%) | BC: 925 (50%) | MB: 270 (50%) | SK: 200 (49%) | NB: 110 (50%) | NE: 138 (50%) | TNL: 88 (50%) | IPE: 20 (50%)
• Private: 575 schools (~40% private TAM)
• Become the reference in school meal management across 10 provinces

**Mission:**
Simplify parents' lives, optimize caterers' operations, and ensure food quality and safety for all children.`
    },
    proprieteIntellectuelle: {
      titre: 'Integrated Intellectual Property',
      intro: `EcoLunch is built on an integrated, systemic, and cross-functional intellectual property, entirely developed in-house and 100% owned by the company.`,
      sectionTitle: 'Intellectual Property Components – EcoTechSystème™',
      donneesTitle: 'Cumulative Proprietary Data',
      donnees: `Daily usage of EcoTechSystème™ generates a unique data asset (food preferences, ordering patterns, user engagement, operational performance, and industry benchmarks), creating a cumulative competitive advantage and significant barriers to entry.`,
      cloture: `ÉcoLuncH™ constitutes an integrated, systemic, and inseparable intellectual property, entirely developed in-house and 100% owned by EcoTechSystème inc.`
    },
    planExecution: {
      titre: 'Operational Execution Plan',
      intro: `This execution plan details the operational implementation to achieve established financial projections. It structures deployment in 4 phases aligned with the roadmap and institutional milestones.`,
      noteAlignement: `This execution plan is strictly aligned with financial projections, roadmap, and institutional milestones presented in the following sections.`
    }
  }
};
